(() => {
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (document.documentElement.dataset.omriyanaMediaProtection) return;
  document.documentElement.dataset.omriyanaMediaProtection = '2026-11-04.2';

  const protectMedia = (media) => {
    if (media.getAttribute('draggable') !== 'false') media.setAttribute('draggable', 'false');
    const resource = media.parentElement;
    if (resource?.matches('.resource-card__media') && !resource.querySelector('.omriyana-media-watermark')) {
      const mark = document.createElement('span');
      mark.className = 'omriyana-media-watermark';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = 'omriyana.com';
      resource.append(mark);
    }
    if (media.tagName !== 'VIDEO') return;
    const controls = new Set((media.getAttribute('controlslist') || '').split(/\s+/).filter(Boolean));
    controls.add('nodownload');
    const list = [...controls].join(' ');
    if (media.getAttribute('controlslist') !== list) media.setAttribute('controlslist', list);
  };

  const scan = (root) => {
    if (!(root instanceof Element) && !(root instanceof Document)) return;
    if (root instanceof Element && root.matches('img, video')) protectMedia(root);
    root.querySelectorAll('img, video').forEach(protectMedia);
  };

  const mediaFromTarget = (target) => {
    if (!(target instanceof Element)) return null;
    if (target.closest('input, textarea, select, [contenteditable]')) return null;
    const media = target.closest('img, picture, video');
    if (media) return media;
    const link = target.closest('a');
    return link?.querySelector('img, video') || null;
  };

  const preventMediaSaving = (event) => {
    if (mediaFromTarget(event.target)) event.preventDefault();
  };

  document.addEventListener('contextmenu', preventMediaSaving, { capture: true });
  document.addEventListener('dragstart', preventMediaSaving, { capture: true });
  scan(document);

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes' && record.target.matches('img, video')) protectMedia(record.target);
      for (const node of record.addedNodes) scan(node);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['draggable', 'controlslist'] });
})();
